import React from "react";
import PropTypes from "prop-types";
import CompanyInvoiceFormList from "../templates/company-invoice-form-list";
import { STATE_STATUS } from "../../../constants";

class InvoiceList extends React.Component {

    componentDidMount() {
        if(this.props.invoicesStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchInvoices(this.props.jobId);
        }
    }

    finalSubmission = _ => {
        this.props.completeParsing(this.state.jobId, _);
        // if (_ === "checker") {
        //     this.props.history.replace("/app/companies/review");
        // }
    }

    invoiceFormListRef = React.createRef();

    onRemove = (invoiceId, remainingInvoices, rejectReason) => {
        this.props.removeInvoice(this.props.jobId, invoiceId, remainingInvoices, remainingInvoices.filter(_ => !_.is_verified).length === 0, rejectReason);
    }

    invoiceValuesSubmit = (invoices, isFinalSubmit) => {
        this.props.updateInvoices(
            this.props.jobId, 
            invoices,
            this.props.isChecker ? "checker" : "maker",
            isFinalSubmit   
        );
    }

    isLoading() {
        if([STATE_STATUS.FETCHING, STATE_STATUS.UPDATING].includes(this.props.invoicesStatus)) {
            return true;
        }
        return false;
    }


    render() {
        return (
            <CompanyInvoiceFormList
                ref={this.invoiceFormListRef}
                isEditable={this.props.isEditable}
                values={this.props.invoices}
                loading={this.isLoading()}
                isChecker={this.props.isChecker}
                onRemove={this.onRemove}
                invoiceValuesSubmit={this.invoiceValuesSubmit}
                finalSubmission={this.finalSubmission}
                dealerCodes ={this.props.dealers}
                history={this.props.history}
            />
        );
    }
}

InvoiceList.propTypes = {
    jobId: PropTypes.string,
    jobStatus: PropTypes.string,
    isEditable: PropTypes.bool,
    invoices: PropTypes.object,
    invoicesStatus: PropTypes.string,
    completeParsing: PropTypes.func,
    fetchInvoices: PropTypes.func,
    updateInvoices: PropTypes.func,
    removeInvoice: PropTypes.func,
    isChecker: PropTypes.bool,
    dealers : PropTypes.object,
    history : PropTypes.object
};

export default InvoiceList;